<ng-container *ngIf="event.points && event.player">
  <div class="teamBadge" [style.background-image]="event.team.image"></div>
  <div class="playerBadge">
    <div class="photo" [style.background-image]="event.player.image"></div>
    <span class="initials">{{ this.utils.getPlayerInitials(event.player.name) }}</span>
  </div>
  <p>
    <span class="title">
      <span class="team">{{ event.team.code }}</span>
      <span class="name"><strong>{{ event.player.name }}</strong></span>
    </span>
    <span class="points"><strong>{{ event.points }} {{ 'PT Shot' | translate }}:</strong></span>
    <span class="result" [class.missed]="event.fail">{{ event.fail ? ('Missed' | translate) : ('Made' | translate) }}</span>
    <span *ngIf="!event.fail && event.assist" class="assist"> {{'·'}} {{ 'Assist' | translate }}: {{ event.assist.name }}</span>
  </p>
  <p>
    <span class="time" [innerHTML]="(event.time | matchTime) + ' (' + event.quarter + ')'"></span>
    <span class="score">
      <span [class.changed]="!event.fail && event.team.isHome">{{ event.result.home }}</span>
      {{'·'}}
      <span [class.changed]="!event.fail && !event.team.isHome">{{ event.result.visitor }}</span>
    </span>
  </p>
</ng-container>
